export default __webpack_public_path__ + "static/garden_design27-007c70e5e3840b6418f1efdc9b183e5d.webp";